import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import styled from "styled-components";
import { HiMenuAlt4 } from "react-icons/hi";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { FiArrowRightCircle } from "react-icons/fi";
import { Row, Col } from "react-grid-system";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import toast, { Toaster } from "react-hot-toast";

import ModalCreateSection from "./ModalCreateSection";
import mainStore from "../../../store/index";
import Loader from "../../utils/Loader";

import { getDatabase, ref, onValue, update, set } from "firebase/database";

const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default function ListSections(props) {
  const STORE = mainStore();

  const [user, setUser] = useState(null);
  const [liststate, setListState] = useState([]);
  const [change, setChanges] = useState(false);

  const [modalsection, setModalSection] = useState(false);
  const [typemodal, setTypeModal] = useState("");
  const [datamodal, setDataModal] = useState(null);

  const [isLoader, setLoader] = useState(false);

  useEffect(() => {
    setUser(STORE.user);

    if (user) {
      getDataSections();
    }
  }, [user]);

  const getDataSections = async () => {
    setLoader(true);
    setListState([]);

    const id = localStorage.getItem("localId");

    try {
      let data;
      const realtime = getDatabase();
      const starCountRef = ref(realtime, "restaurants/" + id);
      onValue(starCountRef, (snapshot) => {
        if (snapshot.exists()) {
          data = snapshot.val();

          const menu = data.menu;
          const newArray = [];
          let itemsCrudo = [];

          if (!menu) {
            setLoader(false);
            return;
          }
          Object.entries(menu).forEach(([key, value]) => {
            newArray.push(value);
            itemsCrudo.push(value);
          });

          itemsCrudo.sort((a, b) => a.position - b.position);
          setListState(itemsCrudo);
          setLoader(false);
        } else {
        }
      });
    } catch (error) {
      setLoader(false);
      toast.error("Opss... ha ocurrido un error😬");
    }
  };

  // functions drag
  const changeDrag = (param) => {
    const srcI = param.source?.index;
    const dropId = param.source?.droppableId;
    const desI = param.destination?.index;
    const dropDes = param.destination?.droppableId;

    if (srcI === desI && dropId === dropDes) return;

    setListState((prevTasks) => reorder(prevTasks, srcI, desI));
    setChanges(true);
  };

  // open crear/editar seccion
  const handleOpenModalSection = (type) => {
    // validar que usuario sea premium para crear una seccion

    let open = !modalsection;
    if (props.data.premium) {
      setTypeModal(type);
      setModalSection(open);
    } else {
      // si no es premium, bloquear modal de crear seccion y mostrar ModalFremium
      if (liststate.length > 2) {
        props.openModalFremium();
      } else {
        setTypeModal(type);
        setModalSection(open);
      }
    }
  };

  const createSection = async (data) => {
    const db = getDatabase();

    if (!props.data.premium) {
      if (liststate.length > 1) {
        props.openModalFremium();
        return;
      }
    }
    setLoader(true);
    const dt = [...liststate];
    const latest = dt;

    let localId = localStorage.getItem("localId");
    const uuidNew = uuidv4();

    let object = {
      ...data,
      id_restaurant: localId,
      position: ++latest.length,
    };

    if (data.name === "") {
      toast.error("Campo nombre y descripción son requeridos.😬👆");
      setLoader(false);
      return;
    }

    const token = localStorage.getItem("token");
    try {
      const createItem = { ...object, id: uuidNew };
      set(
        ref(
          db,
          "/restaurants/" + createItem.id_restaurant + "/menu/" + createItem.id
        ),
        createItem
      );
      getDataSections();
      handleOpenModalSection();

      setLoader(false);
      toast.success("categoría creada con éxito.🤩");
    } catch (error) {
      setLoader(false);
      toast.error("Error al crear la categoría.😬");
    }
  };

  // editar seccion
  const editSection = async (data) => {
    const db = getDatabase();
    setLoader(true);
    try {
      const updates = {};
      updates["/restaurants/" + data.id_restaurant + "/menu/" + data.id] = data;

      toast.success("categoría editada con éxito.");
      setLoader(false);
      return update(ref(db), updates);
    } catch (error) {
      setLoader(false);
      toast.error("Error al editar la categoría.😬:");
    }
  };

  // guardar los cambios del drag
  const saveNewPositions = async () => {
    const db = getDatabase();

    setLoader(true);
    const list = [...liststate];
    let new_list = [];

    let error = false;

    list.map((lt, index) => {
      let dataPosition = { ...lt, position: index };
      new_list.push(dataPosition);

      try {
        const updates = {};
        updates[
          "/restaurants/" +
            dataPosition.id_restaurant +
            "/menu/" +
            dataPosition.id
        ] = dataPosition;

        setLoader(false);
        error = false;
        return update(ref(db), updates);
      } catch (er) {
        error = true;
      }
    });

    if (error) {
      toast.error("Error al editar las categorías.😬");
      setLoader(false);
    } else {
      toast.success("Posiciones de las categorías modificadas correctamente.");
      setChanges(false);
      setLoader(false);
    }
  };

  const deleteSection = async (data) => {
    const db = getDatabase();
    let object = { ...data };

    const o = { id: object.id, id_restaurant: object.id_restaurant };
    try {
      const updates = {};
      updates["/restaurants/" + data.id_restaurant + "/menu/" + data.id] = null;

      toast.success("Seccion eliminada");
      setLoader(false);
      return update(ref(db), updates);
    } catch (error) {
      toast.error("No se pudo eliminar la sesión.😬");
    }
  };

  // obtener datos de la seccion a editar
  const handleEditSection = (data) => {
    setDataModal(data);
    handleOpenModalSection("editar");
  };

  return (
    <>
      {isLoader && (
        <div className="w-100 text-center">
          <Loader color="#3498db" />
        </div>
      )}

      <ContentButton onClick={() => handleOpenModalSection("crear")}>
        <AiOutlinePlusCircle style={{ fontSize: "1.5em", margin: "0 auto" }} />
        Agregar nueva categoría
      </ContentButton>

      <ContentDrag>
        {liststate.length > 0 && (
          <DragDropContext onDragEnd={(param) => changeDrag(param)}>
            <Droppable droppableId="droppable-1" id="droppable-1">
              {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {liststate.map((data, i) => (
                    <Draggable
                      key={data.position}
                      draggableId={`draggable-${data.position}`}
                      index={i}
                    >
                      {(provided, snapshot) => (
                        <ListItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            boxShadow: snapshot.isDragging
                              ? "0px 0px 10px #a8a8a847"
                              : "none",
                          }}
                          onClick={() => handleEditSection(data)}
                        >
                          <Row>
                            <Col xs={2}>
                              <span>
                                <HiMenuAlt4 />
                              </span>
                            </Col>
                            <Col xs={8}>{data.name}</Col>
                            <Col xs={2}>
                              <FiArrowRightCircle />
                            </Col>
                          </Row>
                        </ListItem>
                      )}
                    </Draggable>
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}

        {!isLoader && (
          <>
            {liststate.length === 0 && (
              <div className="text-center">
                {" "}
                <h6>
                  Sin secciones aun🙈
                  <br />
                  <br />
                  Crea una categoría👆
                </h6>
              </div>
            )}
          </>
        )}
      </ContentDrag>

      {liststate.length > 0 && (
        <>
          {change && (
            <ContentSaveChanges>
              {" "}
              <Row>
                <Col xs={12}>
                  <button
                    className="btn btn-success"
                    onClick={() => saveNewPositions()}
                  >
                    Guardar cambios
                  </button>
                </Col>
              </Row>
            </ContentSaveChanges>
          )}
        </>
      )}
      {modalsection && (
        <ModalCreateSection
          createSection={createSection}
          closeModal={handleOpenModalSection}
          editSection={editSection}
          deleteSection={deleteSection}
          type={typemodal}
          data={datamodal}
          loader={isLoader}
        />
      )}

      <Toaster position="bottom-center" reverseOrder={false} />
    </>
  );
}

const ContentButton = styled.div`
  margin-top: 3em;
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  font-size: 1.2em;
`;

const ContentSaveChanges = styled.div`
  width: 100%;
  position: fixed;
  top: auto;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 2em 1em;
  background: #a8a8a839;
  border-top: 1px solid #a8a8a839;
  text-align: center;
  button {
    width: 100% !important;
  }
`;
const ContentDrag = styled.div`
  width: 100%;
  padding: 1em;
  padding-bottom: 4em;
  border-radius: 12px;
  overflow: hidden;
`;
const ListItem = styled.div`
  width: 100%;
  border-bottom: 1px solid #a8a8a85e;
  padding: 2em 1em;
  font-size: 1.2em;
  svg {
    font-size: 1.2em;
    margin-right: 0.2em;
  }
`;
